import { render, staticRenderFns } from "./contentCategoryCreate.vue?vue&type=template&id=d2ae5e6a&"
import script from "./contentCategoryCreate.vue?vue&type=script&lang=js&"
export * from "./contentCategoryCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports